import { connect } from 'react-redux';
import { SaisineContainer } from './saisine.container';
import {
  addClaimToSaisine,
  clearEligibleClaims,
  clearSaisineState,
  deleteSaisine,
  dismissSaisineFlag,
  generateSaisineDocs,
  removeClaimFromSaisine,
  retrieveSaisine,
  searchEligibleClaims,
  validateSaisine,
} from '../../../usecases/saisine.actions';
import {
  selectEligibleClaims,
  selectEligibleLoading,
  selectSaisine,
  selectSaisineActionLoading,
  selectSaisineErrors,
  selectSaisineLoading,
} from '../../../usecases/saisine.selector';

const mapStateToProps = (state) => ({
  search: state.router.location.search,
  saisine: selectSaisine(state),
  loading: selectSaisineLoading(state),
  actionLoading: selectSaisineActionLoading(state),
  errors: selectSaisineErrors(state),
  eligibleClaims: selectEligibleClaims(state),
  eligibleLoading: selectEligibleLoading(state),
});

const mapDispatchToProps = (dispatch) => ({
  retrieveSaisine: (id) => dispatch(retrieveSaisine(id)),
  addClaim: (saisineId, claimId) => dispatch(addClaimToSaisine(saisineId, claimId)),
  removeClaim: (saisineId, claimId) => dispatch(removeClaimFromSaisine(saisineId, claimId)),
  deleteSaisine: (saisineId) => dispatch(deleteSaisine(saisineId)),
  validateSaisine: (saisineId) => dispatch(validateSaisine(saisineId)),
  generateDocs: (claimIds) => dispatch(generateSaisineDocs(claimIds)),
  searchEligibleClaims: (saisineId, text) => dispatch(searchEligibleClaims(saisineId, text)),
  clearEligibleClaims: () => dispatch(clearEligibleClaims()),
  dismissFlag: () => dispatch(dismissSaisineFlag()),
  clearSaisineState: () => dispatch(clearSaisineState()),
});

const SaisinePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SaisineContainer);

export default SaisinePage;
